import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};
@Injectable()
export class ValuesListDoeqService {
  static ENV = environment;
  constructor(private httpService: HttpService) {
    HEADERS['Content-Type'] = 'application/json';
   }

  public getLookupsTypes(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(ValuesListDoeqService.ENV.environment.API.lookups_type_doeq, httpRequesthandler);
  }

  public getLookupsValues(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ValuesListDoeqService.ENV.environment.API.lookups_values_doeq, data, httpRequesthandler);
  }

  public createLookupsValues(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(ValuesListDoeqService.ENV.environment.API.create_lookups_values_doeq, data, httpRequesthandler);
  }

  public deleteLookupsValues(lookup_code: any, httpRequesthandler: HttpRequestHandler): void {
      httpRequesthandler.headers = HEADERS;
      this.httpService.delete(`${ValuesListDoeqService.ENV.environment.API.lookups_values_doeq}/${lookup_code}`,  httpRequesthandler);
  }

  public saveLookupsType(data: any, httpRequesthandler: HttpRequestHandler): void {
      httpRequesthandler.headers = HEADERS;
      this.httpService.post(ValuesListDoeqService.ENV.environment.API.lookups_type_doeq, data, httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/document/values-list-doeq.service.ts